import ProductCard from './porductCard';

export default ProductCard;